import PostCreateFrontLink from './post-create-front-link';

export default PostCreateFrontLink;